import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/site-data";

export const Services = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
                    <div>
                        <p className="text-xs tracking-[0.25em] uppercase text-brand-coral mb-4">What I offer</p>
                        <h2 className="font-display text-4xl sm:text-6xl text-brand-ink max-w-2xl leading-[1.05]">
                            Three services.
                            <br />
                            One <em className="text-brand-coral">joyful</em> experience.
                        </h2>
                    </div>
                    <p className="md:max-w-md text-base text-brand-inkSoft leading-relaxed">
                        Mix any of the three for your event, or book a private henna session
                        for a personal moment.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
                    {SERVICES.map((s, i) => (
                        <motion.a
                            key={s.id}
                            href="#inquiry"
                            data-testid={`service-card-${s.id}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            whileHover={{ y: -6 }}
                            className="group relative bg-white rounded-3xl border border-brand-border overflow-hidden flex flex-col shadow-sm hover:shadow-2xl transition-all duration-500"
                        >
                            <div className="relative h-60 overflow-hidden">
                                <div className={`absolute inset-0 ${s.accent} opacity-30`} />
                                <img
                                    src={s.img}
                                    alt={s.name}
                                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110 mix-blend-multiply"
                                />
                                <div className="absolute top-4 left-4 text-xs tracking-[0.25em] uppercase text-white/95 bg-black/30 backdrop-blur px-3 py-1.5 rounded-full">
                                    {s.kicker}
                                </div>
                            </div>
                            <div className="p-6 flex-1 flex flex-col">
                                <p className="text-xs tracking-[0.2em] uppercase text-brand-coral mb-2">{s.tag}</p>
                                <h3 className="font-display text-2xl text-brand-ink mb-3">{s.name}</h3>
                                <p className="text-brand-inkSoft text-[14px] leading-relaxed flex-1">{s.desc}</p>
                                <div className="mt-5 inline-flex items-center gap-2 text-sm text-brand-ink group-hover:text-brand-coral transition-colors">
                                    Inquire now
                                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                                </div>
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
